import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MenuSideDirective } from '../menu-side.directive';
import { MenuItem } from '../menu.model';
import { IconComponent } from '../../icon/icon.component';

@Component({
    selector: 'skl-menu-item-sub',
    templateUrl: './menu-item-sub.component.html',
    imports: [MenuSideDirective, NgClass, IconComponent]
})
export class MenuItemSubComponent {
    @Input() public item!: MenuItem;
    @Input() public context: unknown;
    @Output() public close: EventEmitter<Event> = new EventEmitter<Event>();

    public disabled!: boolean;

    public constructor() {}

    public ngOnInit() {
        this.disabled = this.item.isDisabled(this.context);
    }

    public getClassNames(): string[] {
        const classNames = [];
        if (this.item.isActive) {
            classNames.push('item-content--active');
        }
        if (this.disabled) {
            classNames.push('item-content--disabled');
        }
        if (this.item.separator) {
            classNames.push('item-content--separator');
        }
        return classNames;
    }

    public onClose(event?: Event): void {
        this.close.emit(event);
    }
}
